<!--公用组件：纯文本提示框
      /**
      * @desc 组件描述
      * @param {Boolean} [closable] - 是否可关闭
      * @param {String} [content] - 文本内容
      * @example 调用示例
      *this.$message("提示信息",false)
      */
-->
<template>
    <div class="message" v-if="visible">
      <div class="message-container fadeInUp animated">
        <div class="message-main">
          {{content}}
        </div>
        <i @click="close" class="message-close" v-if="closable"></i>
      </div>
      <div class="message-mask"></div>
    </div>
</template>

<script>
  export default {
    name: "Message",
    data() {
      return {
        content: 'hello',
        visible: false,
        closable: true
      };
    },
    methods: {
      close(){
           this.visible = false
      }
    }
  };
</script>
<style src="../../static/css/index.css"></style>
<style lang="scss" scoped>
.message{
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
}

.message-mask{
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  top: 0;
  position: fixed;
  background-color: #000;
  opacity: 0.7;
}

.message-container{
  // background-color: #fff;
  position: absolute;
  box-sizing: content-box;
  top: 50%;
  left: 50%;
  z-index: 101;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: 100% 100%;
  @include res-size(
    $padding-top: 15px,
    $padding-bottom: 15px,
    $width: 817px,
    $min-height: 65px,
    $font-size:30px,
  );
}

.message-main{
  text-align: center;
}

.message-close {
  position: absolute;
  left: 0;
  color: #fff;
  background-image: url(../../static/images/close.png);
  background-size: 100% 100%;
  @include res-size($width: 66px, $height: 66px, $top: -79px);
}
</style>




// WEBPACK FOOTER //
// src/components/common-components/features/message/index.vue